module.exports = __webpack_public_path__ + "static/media/n_icon_highlight.dcf63d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_highlight.png
// module id = 1805
// module chunks = 0 1